import type { IStaff } from './staff';
import { staffSchema } from './staff';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { ORGANISATIONS_OUTPUT } from './topics';

export const STAFF_UPDATED = 'ORGANISATIONS/STAFF_UPDATED' as const;

export interface IStaffUpdatedAction {
  type: typeof STAFF_UPDATED;
  payload: IStaff;
}

export const staffUpdatedActionSchema = objectSchemaOf<IStaffUpdatedAction>({
  type: Joi.string().valid(STAFF_UPDATED).required(),
  payload: staffSchema.required(),
});

export const staffUpdated = actionCreator({
  type: STAFF_UPDATED,
  schema: staffUpdatedActionSchema,
  topic: ORGANISATIONS_OUTPUT,
});
